import { BookOpen, Bot, Images, type LucideIcon } from 'lucide-react';

export interface LiksSidebarNavItem {
  labelKey: string;
  path: string;
  icon: LucideIcon;
}

export const SIDEBAR_NAV_ITEMS: LiksSidebarNavItem[] = [
  { labelKey: 'nav.knowledge', path: '/knowledge', icon: BookOpen },
  { labelKey: 'nav.chatbots', path: '/chatbots', icon: Bot },
  { labelKey: 'nav.gallery', path: '/gallery', icon: Images },
];
